var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{attrs:{"primary-title":""}},[_c('h4',[_vm._v("Your details have been saved")])])}
var staticRenderFns = []

export { render, staticRenderFns }